import { render, staticRenderFns } from "./MoveUp.vue?vue&type=template&id=425b3b61"
import script from "./MoveUp.vue?vue&type=script&lang=js"
export * from "./MoveUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports